// redux_files/Inventory/inventorySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth";

export const fetchInventoryReport = createAsyncThunk(
  "inventory/fetchInventoryReport",
  async (
    {
      fromDate,
      toDate,
      res_branch_id,
      categoryID,
      opening_inventory_id,
      ending_inventory_id,
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState();
      const allBranches = state.POSBranches?.rows || [];

      let resolvedBranchId = null;
      const inputRealId = Number(res_branch_id);

      const matched = allBranches.flatMap((group) => {
        const children = group.children || [];
        const found = children.filter((child) => child.realId === inputRealId);
        return found;
      });

      if (matched.length > 0) {
        resolvedBranchId = matched[0].res_branch_id;
      }

      if (resolvedBranchId === null || resolvedBranchId === undefined) {
        throw new Error("Branch ID could not be resolved to res_branch_id");
      }

      const response = await api.post(`/api/inventory-movement/`, {
        fromDate,
        toDate,
        res_branch_id: resolvedBranchId,
        categoryID,
        opening_inventory_id,
        ending_inventory_id,
      });

      console.log("🔍 Data sent to backend:", {
        fromDate,
        toDate,
        res_branch_id: resolvedBranchId,
        categoryID,
        opening_inventory_id,
        ending_inventory_id,
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const inventorySlice = createSlice({
  name: "inventory",
  initialState: {
    data: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchInventoryReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchInventoryReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      });
  },
});

export default inventorySlice.reducer;
